import React from 'react';
import HorizontalScroller from './HorizontalScroller';
import ListingCard from '../../components/ListingCard';

function normalize(x){
  if (!x) return null;
  const cover =
    x.cover_url ||
    x.cover_thumb ||
    x.image ||
    x.img ||
    x.images?.find?.(m => m?.is_main)?.url ||
    x.images?.[0]?.url ||
    null;

  return {
    ...x,
    id: x.id ?? x.slug ?? x.uid ?? `i-${Math.random().toString(36).slice(2,8)}`,
    title: x.title || x.name || x.title_ru || x.title_en || 'Инвест-объект',
    cover_url: cover,
    price: x.price ?? null,
  };
}

export default function InvestSlider({
  items = [],
  perViewDesktop = 4,
  perViewTablet  = 3,
  perViewMobile  = 1,
  perViewTiny    = 1,
  itemMin = 260,
  itemMax = 330,
  pad = 8,
  gap = 12,
}) {
  const list = (Array.isArray(items) ? items : [])
    .map(normalize)
    .filter(Boolean)
    .filter(it => !!it.cover_url); // только с реальной картинкой

  if (!list.length) return null;

  const isCompactDesktop = perViewDesktop <= 2;
  const maxWidthValue = isCompactDesktop
    ? perViewDesktop * itemMax + gap * (perViewDesktop - 1) + pad * 2
    : '100%';
  const shouldLimitDesktop = !isCompactDesktop;

  return (
    <HorizontalScroller
      perViewDesktop={perViewDesktop}
      perViewTablet={perViewTablet}
      perViewMobile={perViewMobile}
      perViewTiny={perViewTiny}
      itemMin={itemMin}
      itemMax={itemMax}
      maxWidth={maxWidthValue}
      centered
      pad={pad}
      gap={gap}
      limitDesktopWidth={shouldLimitDesktop}
    >
      {list.map((it) => (
        <div key={String(it.id)}>
          <ListingCard item={it} />
        </div>
      ))}
    </HorizontalScroller>
  );
}
